module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 01 Farma Pasa - Pustoparan.54ed9b49.mp3";